module.exports = __webpack_public_path__ + "public/img/logo.f4195e9e.png";